import React, { useEffect, useState } from 'react'
import { AdminPagesService, useReturnCurrentPageType } from '../adminPagesSlice'
import Grid from '@mui/material/Grid2';
import { Button, IconButton } from '@mui/material';
import GenerateIcon, { IconTypes } from '../../../components/GenerateIcon';
import Breadcrumbs, { IBreadcrumb } from '../../../components/Breadcrumbs';
import { title } from 'process';
import { Link } from 'react-router-dom';
import { AdminPagesTypes } from '../Interfaces';
import BetaLabel from './BetaLabel';

export interface IPageHeadSectionActionButton {
    icon: IconTypes,
    label: string,
    link?: string,
    onClick?: () => void,
    variant?: 'text' | 'outlined' | 'contained',
    addClassName?: string,
    color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning',
    disabled?: boolean,
    notRouterLink?: boolean
}

interface IProps {
    pageName: string,
    customTitle?: string,
    customActionButtons?: Array<IPageHeadSectionActionButton>,
    customPageType?: AdminPagesTypes,
    hideBreadcrumbs?: boolean,
    triggerBack?: () => void,
}

export const PageHeadSectionActionButton = (props: IPageHeadSectionActionButton) => {

    const { icon, label, link, onClick, variant, addClassName, color, disabled, notRouterLink } = props

    const renderButton = () => {
        return <Button disabled={disabled} color={color ? color : "primary"} onClick={() => onClick ? onClick() : () => {}} className={addClassName ? `general-button admin-style ${addClassName}` : "general-button admin-style"} variant={variant ? variant : "contained"} startIcon={<GenerateIcon icon={icon} />}>{label}</Button>
    }
    
    if (link && !disabled) {

        if (notRouterLink){
            return <a href={link}>{renderButton()}</a>
        }

        return <Link to={link}>{renderButton()}</Link>
    }

    return renderButton()
}

export default function PageHeadSection(props: IProps) {

    const { pageName, customTitle, customActionButtons, customPageType, hideBreadcrumbs, triggerBack } = props

    const currentType = useReturnCurrentPageType()
    const type = customPageType ? customPageType : currentType
    const currentPage = AdminPagesService.usePageDetails(pageName)
    const parentPage = AdminPagesService.usePageDetails(currentPage.subPageName ? currentPage.subPageName : pageName)

    const [breadcrumbsList, setBreadcrumbsList] = useState<Array<IBreadcrumb>>([])

    const [sectionTitle, setSectionTitle] = useState<string>(currentPage.title)

    const [actionButtons, setActionButtons] = useState<Array<IPageHeadSectionActionButton>>(customActionButtons ? customActionButtons : [])

    useEffect(() => {

        let breadcrumbs: Array<IBreadcrumb> = [
            {
                title: "Dashboard",
                link: "/panel/dashboard"
            }
        ]

        if (currentPage.subPageName){
            breadcrumbs.push({
                title: parentPage.title,
                link: "/panel/" + parentPage.name
            })
        }

        if (type == "base"){
            breadcrumbs.push({
                title: currentPage.title
            })
        }

        if (type == "new"){
            breadcrumbs.push({
                title: currentPage.title,
                link: "/panel/" + currentPage.name
            })

            breadcrumbs.push({
                title: currentPage.messages.createShort
            })
        }

        if (type == "edit"){
            breadcrumbs.push({
                title: currentPage.title,
                link: "/panel/" + currentPage.name
            })

            breadcrumbs.push({
                title: currentPage.messages.editShort
            })
        }

        if (type == "view"){
            breadcrumbs.push({
                title: currentPage.title,
                link: "/panel/" + currentPage.name
            })

            breadcrumbs.push({
                title: currentPage.messages.view
            })
        }

        setBreadcrumbsList(breadcrumbs)

    }, [pageName])

    useEffect(() => {

        let buttons: Array<IPageHeadSectionActionButton> = [
            // ...actionButtons
        ]

        if (type == "new"){
            setSectionTitle(currentPage.messages.create)
        }

        if (type == "edit"){
            setSectionTitle(currentPage.messages.edit)
        }

        if (type == "view"){
            setSectionTitle(currentPage.messages.view)
        }

        if (type == "base"){
            buttons.push({
                icon: "new",
                label: currentPage.messages.createShort,
                link: `/panel/${currentPage.name}/new`,
            })
        }

        setActionButtons(buttons)

    }, [type])

    useEffect(() => {
        if (props.customActionButtons){
            setActionButtons(props.customActionButtons)
        }
    }, [props.customActionButtons])

    if (!currentPage.name){
        return <></>
    }

    return(
        <div className="admin-base-page-head-section-container">
            <div className="content-of-admin-base-page-head-section-container">

                <Grid container>

                    <Grid size={{ xs: 10 }}>
                        <div className="text-box-of-admin-base-page-head-section-container">
                            <div className="content-of-text-box-of-admin-base-page-head-section-container">

                                <h2 className="admin-page-header-title">
                                    {triggerBack && <IconButton className="go-back-button-of-admin-head-section-title" onClick={() => triggerBack()}><GenerateIcon icon="prev" /></IconButton>}
                                    {customTitle ? customTitle : sectionTitle}
                                    {currentPage.isBeta && <BetaLabel />}
                                </h2>
                                {!hideBreadcrumbs && <Breadcrumbs breadcrumbs={breadcrumbsList} />}

                            </div>
                        </div>
                    </Grid>

                    <Grid size={{ xs: 2 }}>
                        <div className="action-box-of-admin-base-page-head-section-container">
                            <div className="content-of-action-box-of-admin-base-page-head-section-container">

                               {/* {type !== "new" && (
                                    <Link to={`/panel/${currentPage.name}/new`}>
                                        <Button className="general-button admin-style" variant="contained" startIcon={<GenerateIcon icon="new" />}>{currentPage.messages.createShort}</Button>
                                    </Link>
                               )} */}

                               {actionButtons.map((button, index) => <PageHeadSectionActionButton {...button} key={index} />)}

                            </div>
                        </div>
                    </Grid>

                </Grid>

            </div>
        </div>
    )
}